import React from "react";

type BadgeColor = "primary" | "secondary" | "success" | "warning" | "danger" | "neutral";

const colorClasses: Record<BadgeColor, string> = {
  primary: "bg-primary-50 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300",
  secondary: "bg-secondary-50 text-secondary-700 dark:bg-secondary-900/40 dark:text-secondary-300",
  success: "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
  warning: "bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  danger: "bg-red-50 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  neutral: "bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200",
};

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  color?: BadgeColor;
}

export function Badge({ color = "neutral", className = "", children, ...rest }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${colorClasses[color]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
